// 点赞组件
<template>
  <div class="praise-wrapper">
    <div class="praise-area" id="praise-area" ref="praiseArea">
      <div class="praise-btn" :class="[isBounce ? 'bounce' : '']" ref="praiseBtn" @click="praiseBtnClicked">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Praise",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      isBounce: false,
    };
  },

  computed: {},
  watch: {},
  created() {},
  mounted() {
    // 点赞按钮效果设置
    this.$refs.praiseBtn.addEventListener("animationend", () => {
      this.isBounce = false;
    });

    this.initBubbles()
  },
  destroyed() {},
  methods: {
    // 设定循环点赞气泡
    
    initBubbles() {
      // 产生初始点赞气泡
      this.addPraiseBubble();
      setTimeout(this.addPraiseBubble, 500);
      setTimeout(this.addPraiseBubble, 1000);
      // 循环出现点赞气泡
      setInterval(() => {
        this.addPraiseBubble();
        setTimeout(this.addPraiseBubble, 500);
        setTimeout(this.addPraiseBubble, 1000);
      }, 4000);
    },
    // 点击点赞按钮
    praiseBtnClicked() {
      this.isBounce = true;
      this.addPraiseBubble();
    },
    // 产生点赞气泡
    addPraiseBubble() {
      this.$nextTick(() => {
        const praiseArea = this.$refs.praiseArea;
        const b = Math.floor(Math.random() * 9) + 1; // 设置图片 b1-b9
        const bl = Math.floor(Math.random() * 14) + 1; // bl1~bl14 设置动画效果

        let d = document.createElement("div");
        d.className = `bubble b${b} bl${bl}`;
        d.dataset.t = String(Date.now());

        if (praiseArea !== undefined && d !== undefined) {
          praiseArea.appendChild(d);
        }

        setTimeout(() => {
          // 延时移除元素
          if (praiseArea !== undefined && d !== undefined) {
            praiseArea.removeChild(d);
          }
        }, 2000);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 气泡动画 */
@import "../assets/style/praise.css";

.praise-wrapper {
  position: absolute;
  display: inline-block;
  bottom: 250px;
  z-index: 1000;
}

.praise-area {
  position: relative;
  width: 100px;
}

.praise-btn,
.praise-btn-wrapper {
  position: absolute;
  width: 80px;
  height: 80px;
  bottom: 0px;
  right: 5px;
  transform-origin: bottom;
  background-image: url("../assets/icons/like/like-btn.svg");
  background-repeat: no-repeat;
  background-size: 80px 80px;
  z-index: 1000;
}

.praise-btn-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1005;
}

.bounce {
  animation: bounce 0.2s linear;
  animation-play-state: running;
}

@keyframes bounce {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
</style>